import Ad from '.';

function Billboard(props) {
  // Класс ad-site-billboard НЕ МЕНЯТЬ!!!
  // На этот класс завязана реклама (брендирование)
  return (
    <div className='ad-site-billboard'>
      <Ad
        // Чиним задваивание билборда
        adWillLoad={removeBranding}
        // Удаляем глобальные стили
        adWillUnload={removeBranding}
        {...props}
      />
    </div>
  );
}

export default Billboard;

/**
 * Ad-hoc решение по удалению глобальных стилей при клиентской
 * навигации, а также для исправления ситуации с задваиванием билборда.
 *
 * Подробности тут:
 * https://confluence.rambler-co.ru/x/7v85Ag
 *
 * И тут:
 * https://jira.rambler-co.ru/browse/ADINBX-11079?focusedCommentId=3172603&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-3172603
 */
function removeBranding({ Adf }) {
  if (typeof Adf.util.removeBranding === 'function') Adf.util.removeBranding();
}
